import { NavigationItem } from "./navigationItem";

export class NavItemsDefault {
  items: Array<NavigationItem>;

  constructor() {
    this.items = [
      {
        name: 'Home',
        route: "",
        isDropDown: false,
        external: false,
        topLevel: true
      },
      {
        name: 'Our Rates',
        route: 'units',
        isDropDown: false,
        external: false,
        topLevel: false
      },
      {
        name: 'About Us',
        route: 'about',
        isDropDown: false,
        external: false,
        topLevel: true
      },
      {
        name: 'Size Guide',
        route: 'size-guide',
        isDropDown: false,
        external: false,
        topLevel: true
      },
      {
        name: 'Contact',
        route: 'contact',
        isDropDown: false,
        external: false,
        topLevel: false
      }
    ];
  }

}



// WEBPACK FOOTER //
// ./src/ng2/app/models/navItemsDefault.ts